<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称">
          <el-input v-model="formInline.search" placeholder="请输入昵称或者用户ID"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="中奖状态">
            <el-option label="全部状态" value=""></el-option>
            <el-option label="未中奖" value="10"></el-option>
            <el-option label="中奖" value="20"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.value1" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="record_id" label="ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.user.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="昵称">
            <template slot-scope="scope">
              <span>{{scope.row.user.nickName}}</span></br>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span></br>
              <span class="gray9">(用户等级：{{scope.row.user.grade.name}})</span></br>
            </template>
          </el-table-column>
          <el-table-column prop="use_point" label="消耗积分"></el-table-column>
          <el-table-column prop="describe" label="描述/说明"></el-table-column>
          <el-table-column prop="lottery_text" label="是否中奖">
            <template slot-scope="scope">
              <span :class="scope.row.is_lottery==10?'red':'green'" >{{scope.row.lottery_text}}</span>
              <span v-if="scope.row.is_lottery==20 && scope.row.prize >0" >({{scope.row.receipt_status_text}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="point" label="奖励">
            <template slot-scope="scope">
              <span v-if="scope.row.point > 0">积分:{{scope.row.point}}</span>
              <span v-if="scope.row.prize !=0">礼品:{{scope.row.product.product_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="抽奖时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">返回</el-button>

    </div>
  </div>
</template>

<script>
  import SweepstakesApi from '@/api/sweepstakes.js';
  export default {
    components: {},
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          value1: '',
          status:''
        },
        sweepstakes_id:'',

      };
    },
    created() {
      this.sweepstakes_id = this.$route.query.sweepstakes_id;
      if(this.$route.query.user_id){
        this.formInline.search = this.$route.query.user_id;
      }
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sweepstakes_id = self.sweepstakes_id;
        SweepstakesApi.sweepstakesRecordList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {

        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/record.vue